import axios from 'axios'
import router from '../router'
import { base64Jiami, getUserInfoCache } from '@/tools/common';

import { Toast } from 'vant';

export const newClient = function (env) {

  let apiCommon='';
  let token='';
  let userInfo = getUserInfoCache();
  apiCommon = base64Jiami({
    token: userInfo ? userInfo.token : ''
  });
  console.log(`output->apiCommon`,apiCommon)
  const newClient = axios.create({
    baseURL: env === 'gchao' ? process.env.baseURL : process.env.weiApiUrl,
    timeout: 2*60*1000,
    headers: {
      "systoken": token,
      "api_common":apiCommon,
    },
    withCredentials: true,
  })
  newClient.interceptors.response.use((response) => {

    const data = response.data
    const contentDisposition = response.headers['content-disposition'];
    if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
      // 文件下载
      return response;
    }
    if (data.code === 2) {
      // 未登录
      localStorage.setItem("userInfo", '');
      localStorage.removeItem("userInfo");
      router.push({
        path: '/login'
      })
    } else if(data.code === 40003){
      Toast(window.rootApp.$t('m.device_is_more'));
    } else if(data.code === 40006){
      Toast(window.rootApp.$t('m.Operation_failed'));
    } else {
      return response
      // return Promise.reject(response)
    }
  }, (error) => {
    return Promise.reject(error)
  })
  return newClient
}

/**
 * 上传单个文件（multipart/form-data）
 * @param {File|Blob} file - 要上传的文件对象
 * @param {Object} [options] - 可选参数，会被追加到 formData（例如 flag 等）
 * @returns {Promise<AxiosResponse>} axios 返回值
 */
export const uploadFile = function(file, options = {}) {
  const client = newClient();
  const formData = new FormData();
  formData.append('file', file);
  // 追加额外字段
  Object.keys(options || {}).forEach(key => {
    if (options[key] !== undefined && options[key] !== null) {
      formData.append(key, options[key]);
    }
  });

  // 不手动设置 boundary，让 axios 自动处理 Content-Type
  return client.post('/api/h5/token/upload/file', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}



// WEBPACK FOOTER //
// ./src/api/axios-client-new.js